<template>
  <div class="imgs" v-if="list.length>0">
    <img :src="i" v-for="(i,index) in list" :key="index" @click="maskShow(i)" alt />
  </div>
</template>
<script>
export default {
  name: "imgs",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    maskShow(i) {
      this.$emit("click", i);
    },
  },
};
</script>

<style lang='less' scope>
.img {
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
  img {
    width: 150px;
    height: 150px;
    margin-top: 10px;
  }
}
</style>